import { computed, observable, ObservableMap } from 'mobx';
import { PaginationMeta } from '../../../types';
import { PlaylistSchema, TrackSchema } from '../../../types/schema';
import { APIPaginatedResponse } from '../../api/types';

export class AccountPlaylistsPageModel {}
